var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2895 10.5572V16.748H13.6993V10.97C13.6993 9.51695 13.1792 8.52756 11.8789 8.52756C10.8895 8.52756 10.2958 9.19469 10.0357 9.83921C9.93964 10.071 9.91702 10.3876 9.91702 10.7155V16.7424H6.32692C6.32692 16.7424 6.3778 6.96148 6.32692 5.94947H9.91702V7.48162C9.91702 7.48162 9.90006 7.50423 9.89441 7.51554H9.91702V7.48162C10.3919 6.74663 11.2456 5.7007 13.1509 5.7007C15.5142 5.7007 17.2838 7.24416 17.2838 10.5572H17.2895ZM2.57851 0.748047C1.35165 0.748047 0.548828 1.55653 0.548828 2.61377C0.548828 3.67102 1.32904 4.4795 2.53328 4.4795H2.55589C3.80536 4.4795 4.58558 3.6484 4.58558 2.61377C4.56296 1.55653 3.80536 0.748047 2.57851 0.748047ZM0.758013 16.748H4.34812V5.95512H0.758013V16.748Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.ceb18998e1da9682a206b372764d6ff2.svg";
export { ForwardRef as ReactComponent };